import React from "react";
import BlueLayout from "../layouts/BlueLayout";
import { Link } from "react-router-dom/cjs/react-router-dom";
import Curve from "../components/global/Curve";
import AppHero from "../components/global/AppHero";

const ForPartnersScreen = () => {
  const benefits = [
    {
      colorCard: "bg-cobalt-blue",
      icon: require("../assets/images/for-partners/icon-book.png"),
      colorText: "text-creamy-beige",
      title: "TRAINING SESSIONS",
      description:
        "Get tips on how to host the best virtual experience. Learn about the equipment you need and how to film yourself in the best way. We offer one-on-one support through dedicated Partnership Coordinators, but with larger themes, we organize training sessions for multiple partners to attend at the same time.",
    },
    {
      colorCard: "bg-red",
      icon: require("../assets/images/for-partners/chart-icon.png"),
      colorText: "text-creamy-beige",
      title: "SALES & MARKETING",
      description:
        "Our team and provincial sales partners manage the complete process of promoting your offerings so that you can focus on programming. We are working with school districts, the BC Offshore School System, and private schools to create a community of teachers that are eager to utilize your expertise.",
      colorDescription: "text-night-blue",
    },
    {
      colorCard: "bg-yellow",
      icon: require("../assets/images/for-partners/dolar-icon.png"),
      colorText: "text-night-blue",
      title: "FUNDING OPPORTUNITIES",
      description:
        "We are working with our key partners to identify grants and subsidies to alleviate the financial burden of creating digital educational materials. Wherever possible, we will work with the BC Museums Association to submit grants to provide funding for individual partners as part of larger projects.",
    },
    {
      colorCard: "bg-red",
      icon: require("../assets/images/for-partners/massage-icon.png"),
      colorText: "text-creamy-beige",
      title: "CURRICULUM CONSULTATION",
      description:
        "Let our provincial curriculum experts guide you through the planning process on new experiences and materials. One-on-one sessions are available, as well as opportunities for group training sessions through The VR Voyage Classroom or the BC Museums Association.",
      colorDescription: "text-night-blue",
    },
    {
      colorCard: "bg-sapphire",
      icon: require("../assets/images/for-partners/integrated-icon.png"),
      colorText: "text-creamy-beige",
      title: "INTEGRATED BOOKINGS",
      description:
        "We set up your field trip and presentation options in a way that allows quick bookings by teachers and minimizes the amount of back and forth you have to do with teachers. Integrations with in-house bookings systems are possible to ensure you aren’t creating more work for your team.",
      colorDescription: "text-night-blue",
    },
    {
      colorCard: "bg-canton-jadesheen",
      icon: require("../assets/images/for-partners/search-icon.png"),
      colorText: "text-creamy-beige",
      title: "ANALYTICS",
      description:
        "Understand the demographics and engagement level of your audience. Learn about the classes that enjoy your content the most and help grow your programming in an informed way. Through your account dashboard, you can see which content is popular and where it is most popular.",
      colorDescription: "text-night-blue",
    },
  ];
  return (
    <BlueLayout>
      <div className="bg-night-blue">
        <AppHero
          titleWhite="ADAPTING YOUR STORY"
          titleCanton="TO A NEW WORLD"
          imgSrc={require("../assets/images/for-partners/hero.png")}
          paragraph="Forget endless sales emails and taking focus away from
        programming. The VR Voyage Classroom is developing a teacher
        community from across BC and beyond. Our goal is to create
        connections between your organization and BC classrooms. Whether
        you offer field trips, presentations, or digital educational
        materials, we are here to promote you to a wider audience and
        support your mandate."
          linkBtn="/"
          textBtn="Join Today"
          styleImg="container xl:px-0 mb-10 lg:mb-32 xl:max-w-[548px]"
        />
      </div>
      <Curve color="--var-color-vrc-creamy-beige" />
      <div className="container grid lg:grid-cols-2 lg:w-[80%]">
        <div className="lg:order-2">
          <h2 className="text-canton-jadesheen mt-14">
            STRENGTH THROUGH COMMUNITY
          </h2>
          <p className="py-8">
            The VR Voyage Classroom is a community platform first and foremost.
            By bringing together the unique stories that institutions and
            experts around the province have to share in one centralized place,
            we are able to work together to reach out to classrooms across
            British Columbia. Let us take care of attracting the attention of
            school districts and teachers so that you can focus on what you do
            best, producing exceptional educational programming.
          </p>
          <Link to="/" className="app-button bg-canton-jadesheen">
            Join Today
          </Link>
        </div>
        <div
          className="bg-no-repeat lg:bg-left bg-contain h-96 lg:h-full mt-8"
          style={{
            backgroundImage: `url(${require("../assets/images/for-partners/partner.png")})`,
          }}
        />
      </div>
      <div className="container mt-24 lg:mt-36">
        <h2 className="text-canton-jadesheen text-center">
          BENEFITS OF PARTNERSHIP
        </h2>
        <div className="mt-8 lg:mt-16 grid lg:grid-cols-3 gap-5 mb-24 sticky z-1">
          {benefits.map((e, i) => (
            <div key={i} className={`px-6 py-14 ${e.colorText} ${e.colorCard}`}>
              <img src={e.icon} alt={e.title} className="w-[73px]" />
              <h2 className="my-8">{e.title}</h2>
              <p className={e.colorDescription}>{e.description}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="lg:-mt-[356px]">
        <Curve color="--var-color-vrc-night-blue" />
      </div>
      <div className="bg-night-blue -mt-1">
        <div className="container grid lg:grid-cols-2 lg:pb-10 pt-16 lg:pt-[292px]">
          <div>
            <h2 className="text-canton-jadesheen">
              A DATABASE OF DIGITAL TEACHING RESOURCES
            </h2>
            <p className="text-creamy-beige py-8">
              A resource unlike any other. This database is populated by digital
              resources to help BC teachers with lesson planning. Engaging
              virtual tours, scavenger hunts, interactive quizzes, and digital
              workbooks, all meant to make learning fun. Access to this database
              is by student license and will increase your revenue potential to
              support your organization. To learn more about how you can create
              content for this database, get in touch.
            </p>
            <Link
              to="/contact"
              className="bg-canton-jadesheen uppercase font-oswald w-full lg:w-36 block text-center font-bold py-3"
            >
              Contact
            </Link>
          </div>
          <div
            className="bg-center bg-no-repeat bg-contain lg:bg-right-top h-96 lg:h-[412px] pb-24 lg:pb-0 lg:mt-0 mt-14"
            style={{
              backgroundImage: `url(${require("../assets/images/child-learn.png")})`,
            }}
          />
        </div>
      </div>
    </BlueLayout>
  );
};

export default ForPartnersScreen;
